import React from 'react';
import { Link } from 'react-router-dom';
import { examples, homeQuote } from '../../data/examples';

const WhoWeHelp = () => {
  return (
    <section className="border-y border-[#17211E]/10 bg-[#EAF1EC] py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 bg-[#FAF8F3] p-8 sm:p-10 lg:grid-cols-[1.15fr_.85fr] lg:items-center">
          <div className="border-l-2 border-[#D7B77A] pl-5">
            <p className="home-serif text-2xl leading-snug text-[#174C3C]">
              “{homeQuote.text}”
            </p>
            <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-[#17211E]/45">
              {homeQuote.attribution}
            </p>
          </div>

          <div className="lg:border-l lg:border-[#17211E]/10 lg:pl-8">
            <div className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
              Who we help
            </div>
            <ul className="space-y-3 text-base leading-snug text-[#17211E]/80">
              {examples.map((example) => (
                <li key={example.id}>{example.homeLine}</li>
              ))}
            </ul>
            <Link to="/who-we-help" className="home-link mt-6 inline-block text-base">
              See who we help
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;
